import { FC } from "react";
import BuildingTable from "@/components/buildings/buildingTable";
import RestrictedPage from "@/consumer/restrictedPage";

interface Props {
  subdomain?: string;
}

const Buildings: FC<Props> = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_buildings">
      <BuildingTable />
    </RestrictedPage>
  );
};

export default Buildings;
